import type { BucketRange } from '../_types';

/**
 * Converts an array of bucket indices into a compact list of contiguous ranges.
 *
 * Duplicates are removed, values are clamped to [0, 99], and consecutive
 * indices are merged into a single range.
 *
 * @example
 * bucketsToRanges([0, 1, 2, 3, 10, 11, 12])
 * @returns
 * [{ from: 0, to: 3 }, { from: 10, to: 12 }]
 */
export function bucketsToRanges(buckets: number[]): BucketRange[] {
  const sortedUnique = [...new Set(buckets.filter((bucket) => bucket >= 0 && bucket <= 99))].sort(
    (a, b) => a - b,
  );
  if (sortedUnique.length === 0) return [];

  const ranges: BucketRange[] = [];
  let rangeStart = sortedUnique[0];
  let rangeEnd = sortedUnique[0];

  for (let i = 1; i < sortedUnique.length; i++) {
    const current = sortedUnique[i];
    if (current === rangeEnd + 1) {
      rangeEnd = current;
    } else {
      ranges.push({ from: rangeStart, to: rangeEnd });
      rangeStart = current;
      rangeEnd = current;
    }
  }
  ranges.push({ from: rangeStart, to: rangeEnd });
  return ranges;
}
